"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 19.1",
    width: "24",
    height: "19.1"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M5,19.1c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S6.4,19.1,5,19.1z M5,15.1 c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5C6.5,15.8,5.8,15.1,5,15.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M19,19.1c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S20.4,19.1,19,19.1z M19,15.1 c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5C20.5,15.8,19.8,15.1,19,15.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M17,17.1H7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h10c0.3,0,0.5,0.2,0.5,0.5S17.3,17.1,17,17.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M4.5,10.1c-0.1,0-0.2,0-0.2-0.1C4,10,3.9,9.7,4.1,9.4l1.5-3C5.6,6.3,5.8,6.1,6,6.1h1.5 C7.8,6.1,8,6.4,8,6.6S7.8,7.1,7.5,7.1H6.3L4.9,9.9C4.9,10,4.7,10.1,4.5,10.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M3,17.1H0.5c-0.3,0-0.5-0.2-0.5-0.5v-5.5c0-0.1,0.1-0.3,0.1-0.4l2-2l2.5-4.4C4.7,4.2,4.8,4.1,5,4.1h4.5 c0.3,0,0.5,0.2,0.5,0.5v10c0,0.3-0.2,0.5-0.5,0.5S9,14.9,9,14.6V5.1H5.3L2.9,9.4c0,0-0.1,0.1-0.1,0.1L1,11.4v4.8h2 c0.3,0,0.5,0.2,0.5,0.5S3.3,17.1,3,17.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M23.5,17.1H21c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2v-1H0.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5 h23c0.3,0,0.5,0.2,0.5,0.5v2C24,16.9,23.8,17.1,23.5,17.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M23.5,15.1h-14c-0.3,0-0.5-0.2-0.5-0.5v-3c0-0.3,0.2-0.5,0.5-0.5h14c0.3,0,0.5,0.2,0.5,0.5v3 C24,14.9,23.8,15.1,23.5,15.1z M10,14.1h13v-2H10V14.1z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "#9ECE06",
    points: "13.7,10.6 13.7,0 22.5,5.3     "
  }));
};

exports["default"] = _default;